// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L2ol","colBig":"styles_colBig__3zHtk","colSmall":"styles_colSmall__3XBxU","shopifyNameWrapper":"styles_shopifyNameWrapper__3xmwR"};